export default httpClient => ({
    save: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/propagandas', dados, { headers });
        console.log(dados)
        return {
            data: response.data
        }
    },
    update: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/propagandas/' + dados.get('id'), dados, { headers });
        return {
            data: response.data
        }
    },
    getById: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/propagandas/' + id, { headers });
        return {
            data: response.data
        }
    },
    getAll: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/propagandas', { headers });
        return {
            data: response.data
        }
    },
    getAllSite: async () => {
        const response = await httpClient.get('/colunistas-site');
        return {
            data: response.data
        }
    },
    delete: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/propagandas/' + id, { headers });
        return {
            data: response
        }
    },
    deletarImagem: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/deletar-imagem/' + id, { headers });
        return {
            data: response
        }
    },
    /*---------------SITE------------------*/
    getAds: async () => {
        const response = await httpClient.get('/propagandas-por-pagina/home');
        return {
            data: response.data
        }
    },
    getAdsNoticia: async () => {
        const response = await httpClient.get('/propagandas-por-pagina/noticia');
        return {
            data: response.data
        }
    },
});